<template>
  <div class="overview-container">
    <div class="sidebar-badge">
      <badge
        :src="mappable.pinSrc"
        :number="numberOfTypes"
        :forDetails="true"
        :shiftLeft="!mappable.isActive"
        :whiteNumber="mappable.isScheduled && mappable.isMandatory"
      />
    </div>
    <div class="details-container">
      <span class="address">{{ mappable.name }}</span>
      <small>{{ mappable.types.join(' | ') }}</small>
      <small>Location created {{ mappable.createdAtDateStamp }}</small>
      <small
        >Lat: {{ mappable.latShort }} | Long: {{ mappable.lngShort }}</small
      >
    </div>
  </div>
</template>

<script>
import Badge from '../badge';
export default {
  components: {
    Badge,
  },
  props: {
    mappable: Object,
  },
  computed: {
    numberOfTypes() {
      return this.mappable.typesLength;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';

.sidebar-badge {
  margin: 0.2rem 1rem 0 0;
}

.overview-container {
  display: flex;
  margin-top: -1.5rem;
}

.details-container {
  & .address {
    font-family: Roboto;
    font-size: 12.8px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.87);
  }

  & small {
    display: block;
    font-family: Roboto;
    font-size: 11.2px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.54);
  }
}
</style>
